module.exports = __webpack_public_path__ + "img/point-bg.4200a0ba.png";